import(/* webpackMode: "eager" */ "/codebuild/output/src2238930513/src/dharmayana-website/src/app/(pages)/festivals/layout.tsx");
